import { render, staticRenderFns } from "./CommentTab.vue?vue&type=template&id=50f626f0&scoped=true"
import script from "./CommentTab.vue?vue&type=script&lang=js"
export * from "./CommentTab.vue?vue&type=script&lang=js"
import style0 from "./CommentTab.vue?vue&type=style&index=0&id=50f626f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f626f0",
  null
  
)

export default component.exports